import React from 'react';
import AdnEventCard from '../AdnEventCard';
import type { EventData } from '../../types/events';

const ADN_EVENTS: EventData[] = [
  {
    id: 'adn-fri-18',
    venue: 'adn',
    venueName: 'ADN Oficial',
    title: '🧬 ADN - Spring Day',
    subtitle: '🌺🎧 Recoleta',
    date: '2026-09-18',
    dateLabel: '18/09',
    dayLabel: 'Viernes',
    gradientClass: 'gradient-adn',
    accentColor: '#ff6600',
    borderColor: 'rgba(255, 102, 0, 0.6)',
    glowColor: 'rgba(255, 102, 0, 0.35)',
    djLine: 'Axel Abalo · Sere Dagos · Jean Claudio · Roman Juarez · Jere Gines',
    address: 'Av. Córdoba 1768, Recoleta',
    womenOnly: true,
  },
];

interface AdnOficialTabProps {
  openListaFree: (event: EventData) => void;
}

export default function AdnOficialTab({ openListaFree }: AdnOficialTabProps) {
  return (
    <div className="animate-fade-in">
      {/* Neon Venue Header */}
      <div className="mb-6 text-center px-2">
        <h2
          className="text-5xl sm:text-6xl font-black tracking-tight uppercase leading-none"
          style={{
            color: '#fff',
            textShadow: '0 0 20px #fff, 0 0 50px rgba(255,255,255,0.6), 0 0 80px rgba(255,102,0,0.4)',
          }}
        >
          ADN OFICIAL
        </h2>
        <p
          className="text-xl sm:text-2xl font-black tracking-[0.35em] uppercase mt-1"
          style={{
            color: '#38bdf8',
            textShadow: '0 0 14px #38bdf8, 0 0 30px rgba(56,189,248,0.7), 0 0 50px rgba(56,189,248,0.4)',
          }}
        >
          RECOLETA · BUENOS AIRES
        </p>
        <div
          className="my-4 h-px w-full"
          style={{
            background: 'linear-gradient(90deg, transparent, #ff6600, #ffcc00, #ff6600, transparent)',
            boxShadow: '0 0 10px rgba(255,102,0,0.8), 0 0 20px rgba(255,204,0,0.5)',
          }}
        />
        <p
          className="text-sm sm:text-base font-extrabold tracking-widest uppercase"
          style={{ color: '#ff6600', textShadow: '0 0 12px #ff6600, 0 0 24px rgba(255,102,0,0.6)' }}
        >
          LINE UP SEPTIEMBRE #2026
        </p>
        <p className="text-xs sm:text-sm text-muted-foreground mt-1 font-medium">
          PRÓXIMAS FECHAS – TOCÁ UNA PARA ANOTARTE O RESERVAR
        </p>
      </div>

      {/* Event List */}
      <div className="flex flex-col gap-3 max-w-2xl mx-auto">
        {ADN_EVENTS.map((event) => (
          <AdnEventCard key={event.id} event={event} onListaFree={openListaFree} />
        ))}
      </div>
    </div>
  );
}